import {Component, Input, OnInit} from '@angular/core';
import {DrawerToggleService} from '../drawer/drawer-toggle/drawer-toggle.service';
import {HeaderTitleService} from './header-title.service';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {

  @Input() title = 'Title';

  constructor(private headerTitleService: HeaderTitleService) { }

  ngOnInit() {
    this.headerTitleService.headerTitle$.subscribe(
      value => {
        this.title = value;
      });
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/content-header/content-header.component.ts